import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 收费项
 */
class StorageFeeType extends UltMeta {
    INBOUND = new Meta(1, "入库费");
    OUTBOUND = new Meta(2, "出库费");
    TRANSFER = new Meta(3, "过户费");
}

export const STORAGE_FEE_TYPE = new StorageFeeType();

/**
 * 仓储费用-导出 枚举
 *
 */
class StorageFeeDef extends UltMeta {
    PROJECT = new Meta(1, "关联项目");
    CONTRACT = new Meta(2, "关联合同");
    DATE = new Meta(3, "业务日期");
    GOODS_NAME = new Meta(4, "货物类型");
    WEIGHT = new Meta(5, "数量/重量");
    FEE_TYPE = new Meta(6, "费用类型");
    FEE_STANDARDS = new Meta(7, "收费标准");
    AMOUNT = new Meta(8, "金额（元）");
    DEPOSITOR_NAME = new Meta(9, "存货方");
    WAREHOUSE = new Meta(10, "仓库/库位");
    CREATE_TIME = new Meta(11, "创建时间");
    RELATE_ID = new Meta(12, "来源单据编号");
    TENANT_CONFIG = new Meta(13, "数据来源");
    PLATFORM_PARTNER = new Meta(14, "平台合作方");
}

export const STORAGE_FEE_DEF = new StorageFeeDef();
